import mapping from './mapping';

const root = {
	mapping
};

export default root;
